import './dialog-layout-hr.scss';
import Divider, { DividerProps } from '@mui/material/Divider';
import { FC } from 'react';

interface IProps extends DividerProps {
  className?: string;
}

export const DialogLayoutHr: FC<IProps> = ({
  className = 'dialog-layout-hr',
  orientation = 'horizontal',
  ...otherProps
}) => {
  return (
    <Divider className={className} orientation={orientation} {...otherProps} />
  );
};
